<template>
  <div class="devDetail">
    <!-- 头部简单信息 -->
    <div class="detail-head">
      <div class="avator">
        <device-image
          :name="deviceInfo.code_name"
          :width="100"
          :height="100"
        ></device-image>
      </div>
      <div class="info-keys">
        <div>设备名称:</div>
        <div style="padding: 16px 0">设备类型:</div>
        <div>设备编号:</div>
      </div>
      <div class="info-values">
        <div>{{ deviceInfo.device_name || "-" }}</div>
        <div style="padding: 18px 0">
          {{ deviceInfo.device_class_name || "-" }}
        </div>
        <div>{{ deviceInfo.device_id || "-" }}</div>
      </div>
      <div class="info-keys">
        <div>设备型号:</div>
        <div style="padding: 16px 0">所属商户:</div>
      </div>
      <div class="info-values">
        <div>{{ deviceInfo.code_name || "-" }}</div>
        <div style="padding: 16px 0">
          {{ deviceInfo.business_name || "-" }}
          <span
            v-permission="'change_merchant'"
            class="detail-edit"
            @click="showDialog('business_name')"
            >修改</span
          >
        </div>
      </div>
    </div>
    <!-- 基础信息和上传数据和维保信息 -->
    <div class="detail-body">
      <div class="type-buttons">
        <span
          class="type-button"
          :class="checked === 'baseInfo' ? 'active-button' : ''"
          @click="checkButton('baseInfo')"
          >基础信息</span
        >
        <span
          class="type-button"
          :class="checked === 'upload' ? 'active-button' : ''"
          @click="checkButton('upload')"
          >上报数据</span
        >
        <span
          class="type-button"
          :class="checked === 'repair' ? 'active-button' : ''"
          @click="checkButton('repair')"
          >维保信息</span
        >
      </div>
      <!-- 基础信息 -->
      <div class="base-info" v-show="checked === 'baseInfo'">
        <div class="info-title">生产信息</div>
        <div class="productInfo">
          <div class="info-item">
            <div class="info-keys">
              <div>SN:</div>
              <div style="padding: 16px 0">固件版本号:</div>
              <div>生产厂商:</div>
            </div>
            <div class="info-values">
              <div>{{ deviceInfo.sn || "-" }}</div>
              <div style="padding: 18px 0">
                {{ toDeviceVersion(deviceInfo) }}
              </div>
              <div>
                {{ deviceInfo.manufacturer_name || "-" }}
                <span
                  v-permission="'manufacturer_edit'"
                  class="detail-edit"
                  @click="showDialog('manufacturer_name')"
                  >修改</span
                >
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-keys">
              <div>IMEI:</div>
              <div style="padding: 16px 0">生产批次:</div>
              <div>翻新时间:</div>
            </div>
            <div class="info-values">
              <div>{{ deviceInfo.imei || "-" }}</div>
              <div style="padding: 16px 0; color: #165dff">
                <span @click="getBatchForm">{{
                  deviceInfo.batch_number || "-"
                }}</span>
                <span
                  v-permission="'production_number_edit'"
                  class="detail-edit"
                  @click="showDialog('batch_number')"
                  >修改</span
                >
              </div>
              <div>
                <span>{{ deviceInfo.refurbishedTime || "-" }}</span>
                <span
                  v-permission="'refurbish'"
                  class="detail-edit"
                  @click="refurbish"
                  >翻新</span
                >
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-keys">
              <div>Mac地址:</div>
              <div style="padding: 16px 0">语言:</div>
            </div>
            <div class="info-values">
              <div>{{ deviceInfo.mac || "-" }}</div>
              <div style="padding: 18px 0">
                {{
                  deviceInfo.language === 1
                    ? "中文"
                    : deviceInfo.language === 2
                    ? "英文"
                    : "-"
                }}<span
                  v-permission="'language_edit'"
                  class="detail-edit"
                  @click="showDialog('language')"
                  >修改</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="info-title">绑定用户信息</div>
        <div class="productInfo">
          <div class="info-item">
            <div class="info-keys" style="width: 90px">
              <div style="width: 90px">当前绑定用户:</div>
              <div style="padding-top: 16px">赠送会员:</div>
            </div>
            <div class="info-values">
              <div class="cur-bind-user">
                <el-popover
                  v-if="bindUsers.length"
                  trigger="hover"
                  placement="top"
                >
                  <div v-if="bindUsers.length">
                    <span
                      style="color: #165dff; cursor: pointer"
                      v-for="(item, index) in bindUsers"
                      :key="index"
                      @click="goUserInfo(item)"
                      >{{ item.name
                      }}<span v-if="index + 1 !== bindUsers.length"
                        >、</span
                      ></span
                    >
                  </div>
                  <div slot="reference">
                    <div
                      v-if="bindUsers.length"
                      style="
                        display: -webkit-box;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        white-space: pre-line;
                        cursor: 'pointer';
                      "
                    >
                      <span
                        style="color: #165dff; cursor: pointer"
                        v-for="(item, index) in bindUsers"
                        :key="index"
                        @click="goUserInfo(item)"
                        >{{ item.name
                        }}<span v-if="index + 1 !== bindUsers.length"
                          >、</span
                        ></span
                      >
                    </div>
                  </div>
                </el-popover>
                <div v-else>-</div>
                <!-- <el-popover trigger="hover" placement="top">
                  <div
                    class="bind-user-item"
                    style="color: #165dff"
                    v-for="(item, index) in bindUsers"
                    :key="index"
                    @click="goUserInfo(item)"
                  >
                    {{ item.name || "-"
                    }}<span v-if="index + 1 !== bindUsers.length">、</span>
                  </div>
                </el-popover> -->
              </div>
              <div style="padding-top: 18px">
                {{ deviceInfo.vipName || "-" }}
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-keys">
              <div>国家:</div>
              <div style="padding-top: 16px">会员领取状态:</div>
            </div>
            <div class="info-values">
              <div>
                <!-- {{
                  deviceInfo.user_info
                    ? deviceInfo.user_info[0].country_name || "-"
                    : "-"
                }} -->
                {{ countrys || "-" }}
              </div>
              <div style="padding-top: 18px">
                {{ deviceInfo.vipStatus || "-" }}
                <span
                  class="detail-edit"
                  v-permission="'receive_status_edit'"
                  v-if="deviceInfo.vipStatus === '已领取' && envName !== '国际'"
                  @click="resetBtn"
                  >重置</span
                >
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-keys">
              <div>激活时间:</div>
            </div>
            <div class="info-values">
              <div>
                {{ created_at || "-" }}
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <el-table :data="bindTableData" style="margin-top: 20px; width: 100%">
            <el-table-column
              type="index"
              label="序号"
              width="100"
            ></el-table-column>
            <el-table-column prop="guid" label="用户ID">
              <template slot-scope="scope">
                <span
                  @click="toUserInfo(scope.row.uid)"
                  :style="{
                    color: typeof scope.row.uid === 'number' ? '#165DFF' : '',
                  }"
                  >{{ scope.row.uid || "--" }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="bindTime" label="绑定时间">
              <template slot-scope="scope">
                {{ scope.row.bindTime || "--" }}
              </template>
            </el-table-column>
            <el-table-column prop="unbindTime" label="解绑时间">
              <template slot-scope="scope">
                {{ scope.row.unbindTime || "--" }}
              </template>
            </el-table-column>
            <el-table-column prop="refurbishedTime" label="翻新时间">
              <template slot-scope="scope">
                {{ scope.row.refurbishedTime || "--" }}
              </template>
            </el-table-column>
            <el-table-column prop="unbindTime" label="权益领取" width="270">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.vipRecord && scope.row.vipRecord.length > 0"
                >
                  <div v-for="(i, index) in scope.row.vipRecord" :key="index">
                    <span>{{ i.vipTime }}</span> 领取<span>{{
                      i.vipName
                    }}</span>
                  </div>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              layout="->,total,prev, pager, next"
              @current-change="bindInfoChangePage"
              :total="bindInfoTotal"
              :page-size="bindInfoSize"
              :current-page="bindInfoPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 上传数据 -->
      <div class="uploadData" v-show="checked === 'upload'">
        <div class="info-title">电量信息</div>
        <el-table :data="electricLists" style="margin-top: 20px; width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="100"
          ></el-table-column>
          <el-table-column prop="UserId" label="用户ID"></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
          <el-table-column prop="Electricity" label="电量"></el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            layout="->,total,prev, pager, next"
            @current-change="changepagefn"
            :total="electricTotal"
            :page-size="electricSize"
            :current-page="electricPage"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 维保信息 -->
      <div class="repair-info" v-show="checked === 'repair'">
        <div class="info-title">保修记录</div>
        <div class="repair-log">
          <span>
            保修：<span v-if="deviceInfo.warranty"
              >{{ deviceInfo.warranty }}，保修截止时间{{
                getTime(deviceInfo.warranty_time)
              }}</span
            >
            <span v-else>-</span>
          </span>
          <span
            v-permission="'warranty_edit'"
            class="detail-edit"
            @click="showEditWarranty = true"
            >修改</span
          >
        </div>
        <div class="after-sale">
          <div class="info-title">售后记录</div>
          <span
            v-permission="'creat_after_sales'"
            @click="creatAfterSaleOrder"
            class="detail-edit"
            >发起售后</span
          >
        </div>
        <el-table :data="afterSaleTableData" style="width: 100%">
          <el-table-column prop="code" label="售后单号">
            <template slot-scope="scope">
              <a
                href="javascript:;"
                :style="{
                  color: '#165DFF',
                }"
                @click="toDetail(scope.row)"
              >
                {{ scope.row.code || "--" }}
              </a>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="售后类型">
            <template slot-scope="scope">
              {{ tableCorType(scope.row.category) || "--" }}
            </template>
          </el-table-column>
          <el-table-column prop="device.warranty" label="状态">
            <template slot-scope="scope">
              <div class="status-content">
                <div
                  class="status-color"
                  v-if="scope.row.status"
                  :style="getStatusColor(scope.row.status)"
                ></div>
                {{ dictMap[scope.row.status].name || "--" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="客户">
            <template slot-scope="scope">
              {{ scope.row.customerName || "--" }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="shippedCustomerB" label="寄件地址">
          </el-table-column> -->
          <el-table-column prop="createdAt" label="创建日期"> </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            layout="->,total,prev, pager, next"
            @current-change="repairChangePage"
            :total="repairTotal"
            :page-size="repairSize"
            :current-page="repairPage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改弹窗 -->
    <el-dialog
      :title="dialogTitle"
      width="25%"
      top="30vh"
      :center="true"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="clearDialog"
    >
      <el-form :model="dialogValue" ref="ruleForm">
        <el-form-item
          label="商户机构"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'business_name'"
        >
          <el-cascader
            v-model="dialogValue.value"
            :options="institutionList"
            :show-all-levels="false"
            :props="{ checkStrictly: true }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="生产厂商"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'manufacturer_name'"
        >
          <el-select v-model="dialogValue.value" size="mini">
            <el-option
              v-for="item in productNameList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="生产批次"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'batch_number'"
        >
          <el-input
            v-model="dialogValue.value"
            autocomplete="off"
            placeholder="请输入批次号"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="语言"
          prop="value"
          label-width="80px"
          v-if="dialogType === 'language'"
        >
          <el-select v-model="dialogValue.value" size="mini">
            <el-option label="中文" :value="1"></el-option>
            <el-option label="英文" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批次号查看弹窗 -->
    <el-dialog
      title="批次查看"
      :visible.sync="mskflag"
      :fullscreen="true"
      center
      @close="batchPage = 1"
    >
      <div class="batch-info">
        <span class="info-title">批次编号:</span><span>{{ batchDialogId }}</span
        ><span class="info-title" style="padding-left: 100px">总设备数:</span
        ><span>{{ batchTotal }}台</span>
      </div>
      <div class="table">
        <el-table
          :data="batchTableData"
          empty-text="暂无数据"
          :border="true"
          style="width: 100%"
        >
          <el-table-column align="center" label="设备编码" width="220">
            <template slot-scope="scope">
              <el-button type="text" @click="goDevDetail(scope.row._id)">{{
                scope.row._id || "-"
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="设备型号">
            <template slot-scope="scope">
              {{ scope.row.code_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="固件版本">
            <template slot-scope="scope">
              {{ toDeviceVersion(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="订单类型">
            <template slot-scope="scope">
              {{
                scope.row.production_type === 1
                  ? "量产"
                  : scope.row.production_type === 2
                  ? "试产"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="生产厂商">
            <template slot-scope="scope">
              {{ scope.row.manufacturer_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="语言">
            <template slot-scope="scope">
              {{
                scope.row.language === 1
                  ? "中文"
                  : scope.row.language === 2
                  ? "英文"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            :current-page="batchPage"
            layout="total,prev, pager, next"
            @current-change="currentChangefn"
            :total="batchTotal"
            :page-size="batchSize"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <conDialog
      title="提示"
      contentText="重置后用户重新绑定设备可再次领取会员"
      @conform="resetVIP"
      @cancel="resetDialog = false"
      :isShow="resetDialog"
    ></conDialog>
    <el-dialog
      title="变更保修期"
      :visible.sync="showEditWarranty"
      width="30%"
      top="38vh"
      center
    >
      <div class="warranty-con">
        <span style="width: 48%">请选择保修期到期时间</span
        ><el-date-picker
          style="width: 100%"
          v-model="changeWarranty"
          value-format="yyyy-MM-dd"
          align="right"
          type="date"
          size="mini"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
      <span slot="footer" class="warranty-dialog-footer">
        <el-button @click="showEditWarranty = false">取 消</el-button>
        <el-button
          type="primary"
          style="color: #fff"
          @click="confirmEditWarranty"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { handtime, formatDate, transformKeys, env } from "@/utils/util";
import { getDictMap } from "../../utils/util";
import {
  DeviceLists,
  deviceDetail,
  electricityLists,
  institutionTreeList,
  deviceConfigure,
} from "@/api/device.js";
import DeviceImage from "./../deviceImage";
import conDialog from "../../components/dialog.vue";
export default {
  name: "devDetail",
  components: { DeviceImage, conDialog },
  data() {
    return {
      avator: require("@/assets/images/pic_watch2@2x.png"),
      checked: "baseInfo",
      id: "",
      deviceInfo: {},
      electricLists: [],
      institutionList: [],
      productNameList: [],
      dialogType: "",
      dialogTitle: "",
      dialogFormVisible: false,
      dialogValue: {
        value: "",
      },
      // 电量信息设备数
      electricTotal: 0,
      // 电量信息页码
      electricPage: 1,
      // 电量信息尺寸
      electricSize: 10,
      // 批次号弹窗开关
      mskflag: false,
      // 页码值
      batchPage: 1,
      // 页码尺寸
      batchSize: 20,
      // 批次号
      batchDialogId: "",
      // 总设备数
      batchTotal: 0,
      // 表格数据
      batchTableData: [],
      // 标题对照表
      title: {
        business_name: "修改商户",
        manufacturer_name: "修改生产厂商",
        batch_number: "修改生产批次",
        language: "修改语言",
      },
      envName: "",
      bindUsers: "",
      countrys: "",
      resetDialog: false,
      created_at: "",
      first_bind_time: "",
      bindTableData: [],
      bindInfoTotal: 0,
      bindInfoPage: 1,
      bindInfoSize: 10,
      afterSaleTableData: [],
      tableType: [],
      repairTotal: 0,
      repairSize: 10,
      repairPage: 1,
      showEditWarranty: false,
      changeWarranty: "",
      pickerOptions: {
        disabledDate(time) {
          const startDate = new Date(2020, 0, 1); // 2020年1月1日
          const endDate = new Date();
          endDate.setFullYear(endDate.getFullYear() + 10); // 当前时间加10年
          return time < startDate || time > endDate;
        },
      },
      dictMap: {},
      orderStatus: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.envName = env().title;
    this.dictMap = getDictMap();
    this.productNameList = JSON.parse(localStorage.getItem("productName"));
    this.deviceDetailfn();
    this.getInstitutionList();
  },
  mounted() {
    this.getDict();
    this.getBindRecord();
    this.getAfterSaleInfo();
  },
  filters: {
    handtime,
    handEnd(time) {
      if (time) {
        return time.slice(0, 10);
      }
      return "-";
    },
  },
  computed: {},
  methods: {
    refurbish() {
      this.$confirm("此操作将重置激活时间, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$post(`/device/refurbish?id=${this.deviceInfo._id}`).then(
          (res) => {
            if (res.data.code === 1000) {
              this.$message({ type: "success", message: "翻新成功" });
              this.deviceDetailfn();
              this.getBindRecord();
            } else {
              this.$message({ type: "error", message: "翻新失败" });
            }
          }
        );
      });
    },
    toDetail(val) {
      console.log(val);
      if (this.$jumpPerm("after_sales_order")) {
        this.$router.push({
          path: "/afterSaleOrder",
          query: {
            id: val.id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    toDeviceVersion(row) {
      const { firmware_version, deviceVersion, code_name } = row;

      let devVersion = deviceVersion;
      if (devVersion) {
        if (code_name === "Y006") {
          if (devVersion.length > 8) {
            devVersion = (devVersion * 1).toString(16);
          }
          devVersion = ("00000000" + devVersion)
            .substr(-8)
            .split("")
            .map((s, i) => (i == 0 ? "00" + s : i == 1 || i == 3 ? "0" + s : s))
            .join("")
            .match(new RegExp(".{1,3}", "g"))
            .map((s) => parseInt("0x" + s))
            .join(".");
        } else if (code_name === "Y001S") {
          devVersion = ("00000000" + devVersion)
            .substr(-8)
            .match(new RegExp(".{1,2}", "g"))
            .map((s) => parseInt("0x" + s))
            .join(".");
        }
      }

      if (firmware_version && devVersion) {
        return `${firmware_version} > ${devVersion}`;
      }

      return firmware_version || devVersion || "-";
    },
    tableStatusText(status) {
      return this.dictMap[status].name;
    },
    getStatusColor(status) {
      // const value = this.tableStatus(status);
      const value = this.dictMap[status].code;
      switch (value) {
        case "pre_inspection_of_receiving_goods":
          return { backgroundColor: "#ff7d00" };
        case "under_repair":
          return { backgroundColor: "#165DFF" };
        case "pending_review":
        case "to_be_returned":
        case "to_be_sent_out":
          return { backgroundColor: "#F53F3F" };
        case "returned_inventory":
        case "sent_out":
        case "returned":
          return { backgroundColor: "#00B42A" };
        case "cancelled":
          return { backgroundColor: "#C9CDD4" };
        default:
          return {};
      }
    },
    creatAfterSaleOrder() {
      this.$router.push({
        path: "/afterSaleOrder",
        query: {
          devId: this.id,
          isCreat: true,
        },
      });
    },
    toUserInfo(val) {
      if (typeof val === "number") {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: val,
            tabs: "first",
          },
        });
      }
    },
    confirmEditWarranty() {
      this.showEditWarranty = false;
      console.log("changeWarranty", this.changeWarranty);
      this.$post("/device/edit/configure", {
        _id: this.id,
        warranty_time: this.changeWarranty,
      }).then((r) => {
        console.log("编辑保修期", r);
        if (r.data.code === 1000) {
          this.deviceDetailfn();
          this.$message({
            type: "success",
            message: "修改成功",
          });
        } else {
          this.$message({
            type: "error",
            message: "修改失败",
          });
        }
      });
    },
    getDict() {
      // const orderStatus = findDictItem("process_status");
      // this.orderStatus = {
      //   ...orderStatus,
      //   children: orderStatus.children.filter((i) => i.name !== "提交售后单"),
      // };
      this.orderStatus = this.dictMap["process_status"].children;
      // const tableType = findDictItem("after_sales_type");
      this.tableType = this.dictMap["after_sales_type"].children;
    },
    tableCorType(id) {
      const item = this.tableType.find((i) => id === i.id);
      return item ? item.name : null;
    },
    getTime(time) {
      if (time) {
        return time.slice(0, 10);
      } else {
        return "-";
      }
    },
    getAfterSaleInfo() {
      this.$get("/aftersales/order/list", {
        page: this.repairPage,
        size: 10,
        gdid: this.id,
      }).then((r) => {
        if (r.data.code === 1000) {
          this.repairTotal = r.data.data.count;
          this.afterSaleTableData = r.data.data.list;
        }
      });
    },
    getBindRecord() {
      this.$get("/device/user/lists", {
        page: this.bindInfoPage,
        size: this.bindInfoSize,
        id: this.id,
      }).then((res) => {
        if (res.data.code === 1000) {
          const data = res.data.data;
          this.bindTableData = data.list;
          this.bindInfoTotal = data.count;
        } else {
          this.$message({
            type: "error",
            message: res.data.data.msg,
          });
        }
      });
    },
    resetBtn() {
      this.resetDialog = true;
    },
    //重置会员领取状态
    resetVIP() {
      this.resetDialog = false;
      this.$post(`/device/vip/status/reset?gdid=${this.deviceInfo._id}`).then(
        (res) => {
          if (res.data.code === 1000) {
            this.$message({ type: "success", message: "重置成功" });
            this.deviceDetailfn();
          } else {
            this.$message({ type: "error", message: "重置失败" });
          }
        }
      );
    },
    // 获取商户-机构级联选择菜单
    async getInstitutionList() {
      const { data } = await institutionTreeList();
      if (data.code === 1000) {
        this.institutionList = transformKeys(data.data.data);
      } else {
        this.$message.error(data.msg);
      }
    },
    // tab栏切换
    checkButton(type) {
      this.checked = type;
    },
    // 获取设备详细信息
    async deviceDetailfn() {
      const id = this.id;
      const { data } = await deviceDetail({
        id,
      });
      if (data.code === 1000) {
        this.deviceInfo = data.data.data;
        this.changeWarranty = this.getTime(this.deviceInfo.warranty_time);
        // console.log(this.deviceInfo);
        if (this.deviceInfo.bindUsers.length > 0) {
          this.bindUsers = this.deviceInfo.bindUsers;
          // let name = [];
          let countrys = [];
          this.deviceInfo.bindUsers.forEach((i) => {
            // name.push(i.name);
            countrys.push(i.countryName);
          });
          // this.bindUsers = name.join("、");
          this.countrys = [
            ...new Set(
              countrys.filter(
                (value) => value !== undefined && value !== null && value !== ""
              )
            ),
          ].join("、");
        }
        // if (this.deviceInfo.created_at) {
        //   this.created_at = this.deviceInfo.created_at
        //     .slice(0, 10)
        //     .replace(/-/g, ".");
        // }
        if (this.deviceInfo.first_bind_time) {
          this.created_at = this.deviceInfo.first_bind_time
            .slice(0, 10)
            .replace(/-/g, ".");
        }
        this.electricityListsfn(this.deviceInfo.device_id);
      } else {
        this.$message.error(data.msg);
      }
    },
    // 获取电量列表
    async electricityListsfn(id) {
      const start = "1970-01-01 00:00:00";
      const end = formatDate(new Date(), "YYYY-MM-DD HH:mm:ss");
      const { data } = await electricityLists({
        deviceId: id,
        page: this.electricPage,
        size: this.electricSize,
        start: start,
        end: end,
      });
      if (data.code === 1000) {
        this.electricLists = data.data.data.list;
        this.electricLists.forEach((item) => {
          item.CreateTime = item.CreateTime.replace("T", " ").replace("Z", "");
        });
        this.electricTotal = data.data.data.count;
      }
    },
    // 切换电量表格页码
    changepagefn(index) {
      this.electricPage = index;
      this.electricityListsfn(this.deviceInfo.device_id);
    },
    // 切换绑定用户信息页码
    bindInfoChangePage(index) {
      this.bindInfoPage = index;
      this.getBindRecord();
    },
    // 切换售后记录列表
    repairChangePage(index) {
      this.repairPage = index;
      this.getAfterSaleInfo();
    },
    // 获取批次号表格信息
    async getBatchForm() {
      if (this.deviceInfo.batch_number === "") return;
      this.mskflag = true;
      this.batchDialogId = this.deviceInfo.batch_number;
      const { data } = await DeviceLists({
        page: this.batchPage,
        size: this.batchSize,
        batch_number: this.deviceInfo.batch_number,
      });
      if (data.code === 1000) {
        this.batchTableData = data.data.list;
        this.batchTotal = data.data.count;
      } else {
        this.$message.error(data.msg);
      }
    },
    // 页码值切换
    currentChangefn(index) {
      this.batchPage = index;
      this.getBatchForm();
    },
    // 跳转设备详情
    goDevDetail() {},
    // 打开编辑弹窗
    showDialog(type) {
      this.dialogFormVisible = true;
      this.dialogType = type;
      this.dialogTitle = this.title[type];
      this.dialogValue.value = this.deviceInfo[type];
      if (
        type === "language" &&
        this.deviceInfo.language !== 1 &&
        this.deviceInfo.language !== 2
      ) {
        this.dialogValue.value = "";
      }
    },
    clearDialog() {},
    // 跳转用户信息
    goUserInfo(info) {
      //deviceInfo.user_info[0].user_id || ''
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: info.id,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
      // if (info && info.id) {
      //   this.$router.push({
      //     path: "/userDetail",
      //     query: {
      //       id: info.id,
      //       tabs: "first",
      //     },
      //   });
      // }
    },
    // 编辑提交按钮
    async submitEdit() {
      let params;
      switch (this.dialogType) {
        case "business_name":
          const length = this.dialogValue.value.length;
          params = { business_id: this.dialogValue.value[length - 1] || "" };
          break;
        case "manufacturer_name":
          params = { manufacturer_id: this.dialogValue.value };
          break;
        case "batch_number":
          params = { batch_number: this.dialogValue.value };
          break;
        case "language":
          params = { language: this.dialogValue.value };
          break;
        default:
          break;
      }
      const { data } = await deviceConfigure({
        _id: this.id,
        ...params,
      });
      if (data.code === 1000) {
        this.dialogFormVisible = false;
        this.deviceDetailfn();
      } else {
        this.$message.error(data.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.devDetail {
  width: 100%;
  .detail-head {
    box-sizing: border-box;
    display: flex;
    width: 100%;
    height: 174px;
    padding: 40px;
    background-color: #fff;
    .avatorImg {
      width: 100px;
      height: 100px;
    }
    .info-keys {
      text-align: right;
      width: 156px;
      color: #86909c;
    }
    .info-values {
      padding-left: 16px;
      width: 80%;
      .detail-edit {
        color: #165dff;
        padding-left: 16px;
        cursor: pointer;
      }
    }
  }
  .detail-body {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin-top: 16px;
    padding: 20px;
    background-color: #fff;
    .type-button {
      cursor: pointer;
      display: inline-block;
      width: 88px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 16px;
      margin-right: 12px;
      color: #4e5969;
    }
    .active-button {
      color: #165dff;
      // background-color: #f2f3f5;
      font-weight: 500;
      position: relative;
      display: inline-block;
    }
    .active-button::after {
      content: "";
      position: absolute;
      left: 16px;
      bottom: 0; /* 可以调整下划线与文字的间距 */
      width: 65%; /* 与文本宽度一致 */
      height: 2px; /* 下划线的粗细 */
      background-color: #165dff; /* 下划线的颜色 */
      transition: width 0.3s ease; /* 动画效果 */
    }
    .base-info,
    .uploadData,
    .protect-info {
      padding: 0 12px;
      .info-title {
        padding: 32px 0px 16px;
        font-size: 16px;
        font-weight: 700;
      }
      .productInfo {
        display: flex;
        padding: 16px 12px;
        background-color: #f7f8fa;
        .info-item {
          display: flex;
          flex: 0.33;
        }
        .info-keys {
          color: #86909c;
          width: 90px;
        }
        .info-values {
          padding-left: 32px;
          .cur-bind-user {
            // display: inline-block; /* 使用内联块元素 */
            // max-width: 100px; /* 设置最大宽度，根据需要调整 */
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 不换行 */
            text-overflow: ellipsis;
            // max-width: 80%;
            line-height: 18px;

            // .bind-user-item {
            //   display: inline;
            // }
          }
        }
      }
    }
  }
}
.detail-edit {
  color: #165dff;
  padding-left: 16px;
  cursor: pointer;
}
.repair-info {
  padding: 0 12px;
}
.info-title {
  padding: 32px 0px 16px;
  font-size: 16px;
  font-weight: 700;
}
.repair-log {
  background-color: #f7f8fa;
  padding: 16px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  display: flex;
  justify-content: space-between;
}

.after-sale {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.warranty-con {
  display: flex;
  align-items: center;
}
.warranty-dialog-footer {
  width: 100%;
  display: flex;
  justify-content: right;
  .el-button {
    width: 60px;
    height: 32px;
    background: #f2f3f5;
    border-radius: 2px 2px 2px 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #4e5969;
  }
}
.status-content {
  display: flex;
  width: 68px;
  align-items: center;
  // justify-content: space-between;
}
.status-color {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  // background-color: #ff7d00;
}
</style>
